import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SESSION_KEY = "rg_preloader_seen";

export const Preloader = () => {
    const [visible, setVisible] = useState(() => {
        try {
            return !window.sessionStorage.getItem(SESSION_KEY);
        } catch (_e) {
            return true;
        }
    });

    useEffect(() => {
        if (!visible) return;
        const t = setTimeout(() => {
            try {
                window.sessionStorage.setItem(SESSION_KEY, "1");
            } catch (_e) {
                // ignore
            }
            setVisible(false);
        }, 1500);
        return () => clearTimeout(t);
    }, [visible]);

    useEffect(() => {
        if (!visible) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, [visible]);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    key="preloader"
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="fixed inset-0 z-[200] bg-[#050505] flex items-center justify-center"
                    data-testid="preloader"
                >
                    <div className="flex items-center gap-1 font-poppins font-extrabold text-gold text-7xl md:text-8xl tracking-tight">
                        <motion.span
                            initial={{ opacity: 0, y: 30, rotate: -8 }}
                            animate={{ opacity: 1, y: 0, rotate: 0 }}
                            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                            className="inline-block"
                            data-testid="preloader-letter-r"
                        >
                            R
                        </motion.span>
                        <motion.span
                            initial={{ opacity: 0, y: 30, rotate: 8 }}
                            animate={{ opacity: 1, y: 0, rotate: 0 }}
                            transition={{
                                duration: 0.6,
                                delay: 0.18,
                                ease: [0.22, 1, 0.36, 1],
                            }}
                            className="inline-block"
                            data-testid="preloader-letter-g"
                        >
                            G
                        </motion.span>
                    </div>

                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: "8rem" }}
                        transition={{ duration: 1.2, delay: 0.3, ease: "easeInOut" }}
                        className="absolute bottom-[34%] h-px bg-gold/60"
                    />
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.7, duration: 0.4 }}
                        className="absolute bottom-[28%] font-inter text-[11px] uppercase tracking-[0.4em] text-zinc-500"
                    >
                        Raj Graphics
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Preloader;
